module.exports = __webpack_public_path__ + "img/wulianwang (4).1abfbf8c.png";